/* eslint-disable */
const padlNamespace = 'padl-b2c-es'
window.gtmDataObject = []
window.config = {
    padl: {
        namespace: padlNamespace
    }
}
window[padlNamespace] = { dataLayer: {} }
window[padlNamespace].dataLayer.app = {
    app: {
        affiliation: 'Nespresso Online Store',
        brand: 'Nespresso',
        currency: 'USD',
        landscape: 'NC2-mosaic',
        market: 'WO',
        version: '24.7.13.3',
        isEnvironmentProd: true
    }
}
window[padlNamespace].dataLayer.page = {
    page: {
        pageInfo: {
            language: 'en',
            breadcrumbUID: 'landing-page::::originalline',
            pageName: '',
            primaryCategory: '',
            secondaryCategory: [],
            segmentBusiness: 'B2C',
            technology: [],
            type: '',
            variant: ''
        }
    }
}
window[padlNamespace].dataLayer.user = { isLoggedIn: false }

window[padlNamespace].dataLayer.pageInstanceID = {
    pageInstanceID: 'landing-page::::originalline:NC2-mosaic:true:B2C:US:en'
}

window.padl = {
    app: {
        currency: "EUR",
        deviceType: "Desktop",
        isEnvironmentProd: true,
        landscape: "NC2-mosaic",
        market: "ES"
    }
}
